export default __webpack_public_path__ + "static/media/main-first-page-1.dd01af9c.png";